import React, { Component } from 'react';
import {
  Button,
  Form
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {
  translate
} from 'react-i18next';
class EmailChangeForm extends Component {

  render () {
    let {
      loading,
      oldPassword,
      newEmail,
      emailDuplicate,
      createInputHandler,
      t,
      onSubmit
    } = this.props;
    /*const eMessage = (message) => {
      return t(`passwordChange.errors.${message.toLowerCase().substring(0,20)}`) || message;
    };*/
    const invalidData = emailDuplicate.length <= 3 || newEmail.length <= 3 || newEmail !== emailDuplicate;
    return (
      <Form loading={loading}>
        <Form.Input label={t("emailChange.form.fields.password")} type="password" value={oldPassword} onChange={createInputHandler('oldPassword')} />
        <Form.Input label={t("emailChange.form.fields.newEmail")} type="email" value={newEmail} onChange={createInputHandler('newEmail')} />
        <Form.Input label={t("emailChange.form.fields.newEmailDuplicate")} type="email" value={emailDuplicate} onChange={createInputHandler('emailDuplicate')} />
        <Button disabled={invalidData} primary icon="send" fluid content={t("emailChange.form.buttons.send")} onClick={onSubmit} />
      </Form>
    );
  }

}

EmailChangeForm.propTypes = {
  loading: PropTypes.bool,
  newEmail: PropTypes.string,
  oldPassword: PropTypes.string,
  emailDuplicate: PropTypes.string,
  createInputHandler: PropTypes.func,
  onSubmit: PropTypes.func
};

EmailChangeForm.defaultProps = {
  loading: false,
  error: null
};
const i18nEnhancement = translate('translations')(EmailChangeForm);
export default i18nEnhancement;



// WEBPACK FOOTER //
// ./src/components/forms/EmailChangeForm.jsx